import { rule } from '../../domain/badge-composition-rule.js';
import { arrayMoveElement } from '../../utils/array-utils.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const productRules = composition => {
  const {hasProduct, originalPlanIs} = composition.checkers;

  return [
    rule('product-rules/premium/move-brand-first')
      .when(hasProduct.and(originalPlanIs('premium')))
      .set(() => ({
        input: {
          brands: arrayMoveElement(
            composition.input.brands,
            composition.input.brands.findIndex(brand => brand.name === composition.input.product.brand.name),
            0)
        }
      }))
  ];
};
